import React from "react";
import {Container} from "semantic-ui-react";
import ReferenceGroupsList from "../../../components/torres/reference-group-components/reference-groups-list";

const ReferenceGroupPage = () => {

    return (
        <Container style={{padding: "20px"}}>
            <ReferenceGroupsList/>
        </Container>
    );
};

export default ReferenceGroupPage;
